import * as React from 'react';

export abstract class BasePage<Props, State> extends React.Component<Props, State>
{
    constructor(props:any)
    {
        super(props);
    }

    componentWillReceiveProps(nextProps:any):void
    {
    }

    componentDidMount(): void
    {
    }
}
